import styled from 'styled-components';
import {transparentize} from 'polished';

export const Wrapper = styled.div`
  min-height: 86px;
  border-radius: 5px;
  padding: 10px;
  background-color: ${({theme}) => `
    ${theme.variables.backgroundColor};
  `};
  column-gap: 12px;
  align-items: center;
  grid-template-columns: 146px repeat(2, 1fr) min-content;
  grid-auto-flow: column;
  display: grid;
`;

export const Thumbnail = styled.img`
  grid-row: span 2;
  
  object-fit: cover;
  border-radius: 5px;
  max-width: 146px;
  width: 100%;
  height: 100%;
`;

export const Title = styled.div`
  grid-row: 1;
  grid-column: span 2;
  
  font-size: 14px;
  line-height: 21px;
`;

export const InputContainer = styled.div`
  min-width: 70px;
`;

export const Approaches = styled.div`
  
`;

export const Rest = styled.div`
  
`;

export const Container = styled.div`
  column-gap: 5px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
`;

export const Controls = styled.div`
  grid-column: 4;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
`;

export const Label = styled.span`
  margin: 0 2px;
  display: inline-block;
  line-height: 21px;
  font-size: 14px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
`;
